import React, { useCallback, useMemo } from 'react';
import copy from 'copy-to-clipboard';
import moment from 'moment-timezone';
import { Button, ContentCopyOutlinedIcon, IconButton } from 'tuui';
import { FormattedMessage } from '../../../../taboola-common-frontend-modules/i18n';
import { ModalFormLayout } from '../../../../taboola-common-frontend-modules/modals/components/ModalFormLayout/ModalFormLayout';
import { PAYMENT_STATUS_TYPE } from '../../../config/paymentStatusConsts';
import styles from './koreanKgInicisBankTransferDetailsModal.module.scss';

const expiryDateFormat = 'MMM DD, YYYY HH:mm';

export const KoreanKgInicisBankTransferDetailsModal = ({ onClose, amount, currency, bankTransfer, paymentStatus }) => {
    const formattedExpiryDate = useMemo(
        () => moment.utc(bankTransfer?.virtualAccountExpiryInUtc).local().format(expiryDateFormat),
        [bankTransfer]
    );
    const showBankTransferDetails = paymentStatus !== PAYMENT_STATUS_TYPE.PAID;

    const handleCopyAccountNumberToClipboard = useCallback(
        () => copy(bankTransfer.virtualAccountNumber),
        [bankTransfer]
    );

    return (
        <ModalFormLayout
            hasSubmit={true}
            hasCancel={false}
            onSubmit={onClose}
            submitButtonText={
                <FormattedMessage
                    id="billingAndPayments.modal.bankTransferDetails.kgInicis.close"
                    defaultMessage="Close"
                />
            }
            className={styles['kg-inicis-bank-transfer-details-modal']}
            contentContainerClassName={styles['kg-inicis-bank-transfer-details']}
        >
            {showBankTransferDetails && (
                <div className={styles['sub-header-section']}>
                    <FormattedMessage
                        id="billingAndPayments.modal.bankTransferDetails.kgInicis.subTitle"
                        defaultMessage={`Transfer ${amount} ${currency} to this bank account:`}
                        values={{ amount, currency }}
                    />
                </div>
            )}

            <div className={styles['sub-header-section']}>
                <div className={styles['sub-header-title']}>
                    <FormattedMessage
                        id="billingAndPayments.modal.bankTransferDetails.kgInicis.bankName"
                        defaultMessage="Bank Name"
                    />
                </div>
                <div>
                    <FormattedMessage
                        id={`billingAndPayments.modal.addFunds.BANK_TRANSFER.kgInicis.virtualAccountBanks.dropdown.${bankTransfer.virtualAccountBankCode}.label`}
                    />
                </div>
            </div>
            <div className={styles['sub-header-section']}>
                <div className={styles['sub-header-title']}>
                    <FormattedMessage
                        id="billingAndPayments.modal.bankTransferDetails.kgInicis.accountNumber"
                        defaultMessage="Account Number"
                    />
                </div>
                <div className={styles['sub-header-value-copy-to-clipboard']}>
                    {bankTransfer.virtualAccountNumber}
                    <IconButton
                        onClick={handleCopyAccountNumberToClipboard}
                        variant={Button.variant.ghost}
                        className={styles['icon-button']}
                        size={Button.size.sm}
                    >
                        <ContentCopyOutlinedIcon fontSize="small" />
                    </IconButton>
                </div>
            </div>
            <div className={styles['sub-header-section']}>
                <div className={styles['sub-header-title']}>
                    <FormattedMessage
                        id="billingAndPayments.modal.bankTransferDetails.kgInicis.accountHolder"
                        defaultMessage="Account Holder"
                    />
                </div>
                <div>
                    <span>{bankTransfer.virtualAccountHolderName}</span>
                </div>
            </div>
            <div>
                <FormattedMessage
                    id="billingAndPayments.modal.bankTransferDetails.kgInicis.expirationDate"
                    defaultMessage={`The virtual bank transfer is valid until ${formattedExpiryDate}`}
                    values={{ formattedExpiryDate }}
                />
            </div>
        </ModalFormLayout>
    );
};
